import { Box, Button, Icon, Image, Text } from '@fairfashion/design-system'
import parse from 'html-react-parser'

import * as QRCodeDetailsStyles from '../../qrcode-details.styles'

import { ItemTraceabilityStepCardProps } from './item-traceability-step-card.types'

export const ItemTraceabilityStepCard = ({
  itemTraceabilityStep,
  onEdit,
}: ItemTraceabilityStepCardProps) => {
  const getImageName = (url: string) => {
    const split = url.split('/')
    const name = split[split.length - 1]

    return name.split('?')[0]
  }

  if (!itemTraceabilityStep?.description) {
    return (
      <QRCodeDetailsStyles.Card direction="column" gap={3}>
        <Box width="100%" justifyContent="space-between" alignItems="center">
          <Text fontWeight={500}>
            {itemTraceabilityStep.name || itemTraceabilityStep.title}
          </Text>
          <Box gap={2}>
            <Button padding="10px 14px" onClick={onEdit}>
              <Box gap={1} alignItems="center">
                <Icon name="add" color="white" />
                <Text color="white" size="small">
                  Cadastrar
                </Text>
              </Box>
            </Button>
          </Box>
        </Box>
      </QRCodeDetailsStyles.Card>
    )
  }

  return (
    <QRCodeDetailsStyles.Card direction="column" gap={3}>
      <Box width="100%" justifyContent="space-between" alignItems="center">
        <Text fontWeight={500}>{itemTraceabilityStep.name}</Text>
        <Box gap={2}>
          <Button padding="10px 14px" onClick={onEdit}>
            <Box>
              <Icon name="edit" color="white" />
              <Text color="white" size="small">
                Editar
              </Text>
            </Box>
          </Button>
        </Box>
      </Box>

      <Box direction="column" gap={1}>
        <Text color="grey_2">Descrição curta</Text>
        <Text size="small" fontWeight={300}>
          {itemTraceabilityStep.shortDescription}
        </Text>
      </Box>

      <Box direction="column" gap={1}>
        <Text color="grey_2">Descrição</Text>
        <Text size="small" fontWeight={300} width="100%">
          {parse(itemTraceabilityStep.description)}
        </Text>
      </Box>

      <Box direction="column" gap={1}>
        <Text color="grey_2">Vídeos</Text>
        {itemTraceabilityStep?.assets?.videos?.map((v) => (
          <a href={v} target="_blank" rel="noreferrer">
            <Box gap={1}>
              <Text color="gray_blue" size="small">
                {v}
              </Text>
              <Icon name="external_link" size={16} color="gray_blue" />
            </Box>
          </a>
        ))}
      </Box>

      <Box direction="column" gap={1}>
        <Text color="grey_2">Anexos</Text>
        <Box
          width="100%"
          flexWrap="wrap"
          gap={2}
          justifyContent="space-between"
        >
          {itemTraceabilityStep?.assets?.images?.map((i) => (
            <a href={i} target="_blank" rel="noreferrer">
              <Box gap={1} alignItems="center">
                <Box
                  width="48px"
                  height="48px"
                  borderRadius="8px"
                  overflow="hidden"
                  border={{
                    color: 'grey_5',
                    width: 1,
                  }}
                >
                  <Image
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    src={i || '/assets/default-image.png'}
                    alt="Attachment"
                  />
                </Box>
                <Text size="small">{getImageName(i)}</Text>
              </Box>
            </a>
          ))}
        </Box>
      </Box>
    </QRCodeDetailsStyles.Card>
  )
}
